import { useLocalStorage } from '@mantine/hooks';

export function useDevMode() {
    return useLocalStorage({ key: 'is-dev' });
}
